import type { SelectedTimePeriod } from "replo-utils/analytics";

import { getRangesFromTimePeriod } from "replo-utils/analytics";
import { convertDaysToMs } from "replo-utils/lib/datetime";

const HOUR_OPTION = {
  value: "hour",
  label: "hour",
};
const DAY_OPTION = { value: "day", label: "day" };

export function getChartIntervalOptions(
  selectedTimePeriod: SelectedTimePeriod,
  timeZone: string,
) {
  const { updatedRanges } = getRangesFromTimePeriod({
    selectedTimePeriod,
    timeZone,
  });
  const { startDatetime, endDatetime } = updatedRanges.mainRange;
  const start = new Date(startDatetime);
  const end = new Date(endDatetime);

  const rangeInDays = Math.ceil(
    (end.getTime() - start.getTime()) / convertDaysToMs(1),
  );

  let intervalOptions: { label: string; value: string }[] = [];

  if (rangeInDays <= 1) {
    intervalOptions = [HOUR_OPTION];
  } else if (rangeInDays <= 31) {
    intervalOptions = [HOUR_OPTION, DAY_OPTION];
  } else {
    intervalOptions = [DAY_OPTION];
  }

  return { intervalOptions };
}
